// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FALWqPcIS4g9eCp2rVmL{border:1px solid var(--interaction-neutral-normal);border-radius:12px;grid-template-columns:max-content 1fr max-content;padding:15px 14px 24px;display:grid}.rfJy5XN1Ek9yfmXAC_u4{padding-left:12px;padding-right:16px}.rfJy5XN1Ek9yfmXAC_u4 .sYYHo83wBNQykAVX7xeM{flex-direction:column;gap:8px;display:flex}.rfJy5XN1Ek9yfmXAC_u4 .FzfhlwJhRDojpPbsRUpm{margin-top:16px;position:relative}.RtvLrR_mStclFF0sueBo{padding:4px}.o5yGKGCpvYIzypplVEa0{border-top:1px solid var(--border-neutral-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FALWqPcIS4g9eCp2rVmL`,
	"center": `rfJy5XN1Ek9yfmXAC_u4`,
	"info": `sYYHo83wBNQykAVX7xeM`,
	"select": `FzfhlwJhRDojpPbsRUpm`,
	"newBtnWrap": `RtvLrR_mStclFF0sueBo`,
	"searchInput": `o5yGKGCpvYIzypplVEa0`
};
export default ___CSS_LOADER_EXPORT___;
